import { memo, useEffect } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "stores";

import Header from "containers/Header";
import ConfirmTermsAgreement from "containers/ConfirmTermsAgreement";
import { updateUserAccessStatus } from "stores/modules/entities.user.setting/operations";
import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { subscribeUserState } from "stores/modules/app.user/operations";

const PageNotFound = () => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const settingsUid = useAppSelector((state) => state.entities.userSetting.uid);

  useEffect(() => {
    return dispatch(subscribeUserState());
  }, [dispatch]);

  useEffect(() => {
    if (settingsUid) {
      dispatch(updateUserAccessStatus());
    }
  }, [dispatch, settingsUid]);

  return (
    <Wrapper>
      <Header />
      <Container>
        <Paper>
          <Box p={2}>
            <Typography variant="h5" align="center" gutterBottom>
              {t("指定されたページは存在しません")}
            </Typography>
            <Typography variant="body2" align="center">
              {t("URLに誤りがないかご確認ください。")}
            </Typography>
          </Box>
        </Paper>
      </Container>
      <ConfirmTermsAgreement />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`;

const Container = styled.div`
  margin: auto auto;
`;

export default memo(PageNotFound);
